// eslint-disable-next-line import-x/no-extraneous-dependencies
import PlacesAutocompleteImport, {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng,
} from 'react-places-autocomplete';

import { resolveCjsDefaultExport } from './ReactPlacesAutocomplete.helpers';

const PlacesAutocomplete = resolveCjsDefaultExport(PlacesAutocompleteImport);

export { geocodeByAddress, geocodeByPlaceId, getLatLng, PlacesAutocomplete };
export type {
  AutocompletePrediction,
  PropTypes,
  Suggestion,
} from 'react-places-autocomplete';
